"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerOrderDishAddOnUpdateSchema = exports.CustomerOrderDishAddOnUpdateScalarSchema = exports.CustomerOrderDishAddOnCreateSchema = exports.CustomerOrderDishAddOnCreateScalarSchema = exports.CustomerOrderDishAddOnPrismaUpdateSchema = exports.CustomerOrderDishAddOnPrismaCreateSchema = exports.CustomerOrderDishAddOnSchema = exports.CustomerOrderDishAddOnScalarSchema = void 0;
// @ts-nocheck
const zod_1 = require("zod");
const DishAddOnCategoryType_schema_1 = require("../enums/DishAddOnCategoryType.schema");
const baseSchema = zod_1.z.object({
    nameEN: zod_1.z.string().min(1, { message: "Name must be between 1 and 100 characters" }).max(100, { message: "Name must be between 1 and 100 characters" }),
    nameFR: zod_1.z.string().min(1, { message: "Name must be between 1 and 100 characters" }).max(100, { message: "Name must be between 1 and 100 characters" }),
    descriptionEN: zod_1.z.string().max(1000, { message: "Description must be between 0 and 1000 characters" }).nullish(),
    descriptionFR: zod_1.z.string().max(1000, { message: "Description must be between 0 and 1000 characters" }).nullish(),
    priceCents: zod_1.z.number(),
    id: zod_1.z.string().uuid(),
    dishAddOnIdAtOrderTime: zod_1.z.string().uuid(),
    categoryType: DishAddOnCategoryType_schema_1.DishAddOnCategoryTypeSchema,
    categoryNameEN: zod_1.z.string(),
    categoryNameFR: zod_1.z.string(),
    quantity: zod_1.z.number(),
    discount: zod_1.z.number(),
    unitEffectivePriceInCents: zod_1.z.number(),
}).strict();
const relationSchema = zod_1.z.object({
    customerOrderDish: zod_1.z.record(zod_1.z.unknown()),
});
const fkSchema = zod_1.z.object({
    customerOrderDishId: zod_1.z.string().uuid(),
});
/**
 * `CustomerOrderDishAddOn` schema excluding foreign keys and relations.
 */
exports.CustomerOrderDishAddOnScalarSchema = baseSchema;
/**
 * `CustomerOrderDishAddOn` schema including all fields (scalar, foreign key, and relations) and validations.
 */
exports.CustomerOrderDishAddOnSchema = exports.CustomerOrderDishAddOnScalarSchema.merge(fkSchema).merge(relationSchema.partial());
/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
exports.CustomerOrderDishAddOnPrismaCreateSchema = baseSchema.partial().passthrough();
/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
exports.CustomerOrderDishAddOnPrismaUpdateSchema = zod_1.z.object({
    nameEN: zod_1.z.string().min(1, { message: "Name must be between 1 and 100 characters" }).max(100, { message: "Name must be between 1 and 100 characters" }),
    nameFR: zod_1.z.string().min(1, { message: "Name must be between 1 and 100 characters" }).max(100, { message: "Name must be between 1 and 100 characters" }),
    descriptionEN: zod_1.z.string().max(1000, { message: "Description must be between 0 and 1000 characters" }).nullish(),
    descriptionFR: zod_1.z.string().max(1000, { message: "Description must be between 0 and 1000 characters" }).nullish(),
    priceCents: zod_1.z.union([zod_1.z.number(), zod_1.z.record(zod_1.z.unknown())]),
    id: zod_1.z.string().uuid(),
    dishAddOnIdAtOrderTime: zod_1.z.string().uuid(),
    categoryType: DishAddOnCategoryType_schema_1.DishAddOnCategoryTypeSchema,
    categoryNameEN: zod_1.z.string(),
    categoryNameFR: zod_1.z.string(),
    quantity: zod_1.z.union([zod_1.z.number(), zod_1.z.record(zod_1.z.unknown())]),
    discount: zod_1.z.union([zod_1.z.number(), zod_1.z.record(zod_1.z.unknown())]),
    unitEffectivePriceInCents: zod_1.z.union([zod_1.z.number(), zod_1.z.record(zod_1.z.unknown())])
}).partial().passthrough();
/**
 * `CustomerOrderDishAddOn` schema for create operations excluding foreign keys and relations.
 */
exports.CustomerOrderDishAddOnCreateScalarSchema = baseSchema;
/**
 * `CustomerOrderDishAddOn` schema for create operations including scalar fields, foreign key fields, and validations.
 */
exports.CustomerOrderDishAddOnCreateSchema = exports.CustomerOrderDishAddOnCreateScalarSchema.merge(fkSchema);
/**
 * `CustomerOrderDishAddOn` schema for update operations excluding foreign keys and relations.
 */
exports.CustomerOrderDishAddOnUpdateScalarSchema = baseSchema.partial();
/**
 * `CustomerOrderDishAddOn` schema for update operations including scalar fields, foreign key fields, and validations.
 */
exports.CustomerOrderDishAddOnUpdateSchema = exports.CustomerOrderDishAddOnUpdateScalarSchema.merge(fkSchema.partial());
